import React from 'react'
import { Menu } from '@mui/material'

import { Option } from './SentimentOptions'
import { MenuItemWrapper } from './SentimentHelper'

interface SentimentMenuProps {
  anchorEl?: null | HTMLElement
  open?: boolean
  onClose?: () => void
  options?: Option[]
  selectedOption?: Option | null
  onChange?: (option: Option) => void
}

const SentimentMenu: React.FC<SentimentMenuProps> = ({
  anchorEl = null,
  open = false,
  onClose,
  options = [],
  selectedOption = null,
  onChange,
}) => (
  <Menu
    anchorEl={anchorEl}
    open={open}
    onClose={onClose}
    MenuListProps={{
      'aria-labelledby': 'sentiment-dropdown-menu',
    }}
  >
    {options.map((option: Option) => (
      <MenuItemWrapper
        key={option.value}
        option={option}
        onChange={() => onChange && onChange(option)}
        selected={selectedOption}
      />
    ))}
  </Menu>
)

export default SentimentMenu
